import { useEffect, useRef } from 'react';

/**
 * Custom hook that uses IntersectionObserver to add '.revealed' class
 * to elements with '.scroll-reveal' when they enter the viewport.
 */
const useScrollReveal = (containerRef) => {
    const observerRef = useRef(null);

    useEffect(() => {
        const container = containerRef?.current || document;

        observerRef.current = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('revealed');
                        observerRef.current.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
        );

        const elements = container.querySelectorAll
            ? container.querySelectorAll('.scroll-reveal')
            : document.querySelectorAll('.scroll-reveal');

        elements.forEach((el) => observerRef.current.observe(el));

        return () => {
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, [containerRef]);
};

export default useScrollReveal;
